import cx from "classnames"
import { useState, useRef } from "react"
import * as css from "./AccordionItem.module.css"

function AccordionItem({ faq }) {
  const [clicked, setClicked] = useState(false)
  const contentEl = useRef()

  const { question, answer } = faq

  const handleToggle = () => {
    setClicked((prev) => !prev)
  }

  return (
    <li
      className={cx(css.accordionItem, { [css.active]: !!clicked })}
      onClick={handleToggle}
    >
      <button className={css.accordionButton} type="button">
        {question}
      </button>

      <div
        ref={contentEl}
        className={css.accordionPanel}
        style={
          clicked
            ? { height: contentEl.current.scrollHeight }
            : { height: "0px" }
        }
      >
        <div
          className={css.answer}
          dangerouslySetInnerHTML={{
            __html: answer,
          }}
        />
      </div>
    </li>
  )
}

export default AccordionItem
